import api, { getResponseError } from '../../services/api'
import { fromDatetimeLocalToIso, toDatetimeLocal } from '../functions/dateTime'
import { IErrorResponse, IResponse } from '../types/ErrorResponse'
import {
  ProductTicketFormValues,
  TicketStatusEnum,
  TProductTicketLogPagination,
  TProductTicketPagination,
} from '../types/Tickets'

export interface IProductTicketsProp {
  productId: string
  page: number
  rows: number
  search?: string
  status?: TicketStatusEnum | null
}

const getByProduct = async ({
  productId,
}: {
  productId: string
}): Promise<ProductTicketFormValues | IErrorResponse> => {
  try {
    const { data } = await api.get<ProductTicketFormValues>(
      `/Ticket/${productId}/form`
    )
    if (data) {
      if (data.areas) {
        data.areas = data.areas.map((area) => {
          area.lots = area.lots.map((lot) => {
            if (lot.startDate && lot.endDate) {
              lot.startDate = toDatetimeLocal(lot.startDate)
              lot.endDate = toDatetimeLocal(lot.endDate)
            }
            console.log(lot)
            return lot
          })
          return area
        })
      }
      return data
    }

    return {
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      code: 2,
      error: e,
    }
  }
}

const getAll = async ({
  productId,
  page,
  rows,
  search,
  status,
}: IProductTicketsProp): Promise<TProductTicketPagination | IErrorResponse> => {
  try {
    var url = `/Ticket/${productId}/list?PageNumber=${page}&RowsPerPage=${rows}`

    if (search && search !== '') {
      url += `&Search=${search}`
    }

    if (status !== null && status !== undefined) {
      url += `&Status=${status}`
    }

    const { data } = await api.get<TProductTicketPagination>(url)
    if (data) {
      return data
    }

    return {
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      code: 2,
      error: e,
    }
  }
}

const getLogs = async ({
  productId,
  page,
  rows,
  search,
}: IProductTicketsProp): Promise<
  TProductTicketLogPagination | IErrorResponse
> => {
  try {
    var url = `/Ticket/${productId}/logs?PageNumber=${page}&RowsPerPage=${rows}`

    if (search && search !== '') {
      url += `&Search=${search}`
    }

    const { data } = await api.get<TProductTicketLogPagination>(url)
    if (data) {
      return data
    }

    return {
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      code: 2,
      error: e,
    }
  }
}

const register = async ({
  productId,
  areas,
}: {
  productId: string
} & ProductTicketFormValues): Promise<IResponse> => {
  const body = {
    areas: areas.map((area) => ({
      ...area,
      lots: area.lots.map((lot) => ({
        ...lot,
        startDate: lot.startDate
          ? fromDatetimeLocalToIso(lot.startDate as string)
          : null,
        endDate: lot.endDate
          ? fromDatetimeLocalToIso(lot.endDate as string)
          : null,
      })),
    })),
  }
  try {
    const { data: response } = await api.put(`/Ticket/${productId}/form`, body)
    if (response) {
      return {
        success: true,
        code: 0,
        error: '',
        data: response,
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error: any) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const processOrResend = async ({
  orderCode,
}: {
  orderCode: string
}): Promise<IResponse> => {
  try {
    const { data: response } = await api.post<string>(
      `/Ticket/order/${orderCode}/process-or-resend`
    )

    return {
      success: true,
      code: 0,
      error: '',
      data: response,
    }
  } catch (error: any) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

// Reprocessa a sincronização dos ingressos do pedido com o Celetus Pass
// (reenvia os que estão NotSent/Rejected). Idempotente no backend.
const resendCeletusPass = async ({
  orderCode,
}: {
  orderCode: string
}): Promise<IResponse> => {
  try {
    const { data: response } = await api.post<string>(
      `/Ticket/order/${orderCode}/resend-celetus-pass`
    )

    return {
      success: true,
      code: 0,
      error: '',
      data: response,
    }
  } catch (error: any) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const TicketController = {
  getByProduct,
  getAll,
  getLogs,
  register,
  processOrResend,
  resendCeletusPass,
}

export default TicketController
